module.exports = __webpack_public_path__ + "static/media/Search.94060142.svg";